/* unplugin-vue-components disabled */import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import "./text.vue?vue&type=style&index=0&id=3e2e26b1&lang=scss"

const __exports__ = script;

export default __exports__